import type { JobRepairReceivableDto } from '@vatos-pas/common';

export interface ReceivableRowEdits {
  poTotalOverride?: number | string;
  internalInvoice?: string;
  readyToBook?: boolean;
}

/**
 * Body for PATCH job-repair/:id/receivable from what the operator edited in
 * the row. Only edited keys are sent: an untouched override, invoice or flag
 * is left alone by the API (which also locks the override at the PO Total on
 * the first submit), so nothing read from the row is echoed back and another
 * user's concurrent change is not overwritten.
 */
export function buildReceivablePayload(
  edits: ReceivableRowEdits | undefined,
): JobRepairReceivableDto {
  const payload: JobRepairReceivableDto = {};
  if (!edits) return payload;

  if (
    edits.poTotalOverride !== undefined &&
    edits.poTotalOverride !== null &&
    `${edits.poTotalOverride}`.trim() !== ''
  ) {
    payload.poTotalOverride = parseFloat(`${edits.poTotalOverride}`);
  }
  if (edits.internalInvoice) {
    payload.internalInvoice = edits.internalInvoice;
  }
  if (edits.readyToBook !== undefined) {
    payload.readyToBook = edits.readyToBook;
  }

  return payload;
}
